import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { RecebimentoService } from 'contabil-lib';
import { Convenio, FuncaoService, Login } from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { tsXLXS } from 'ts-xlsx-export';

@Component({
  selector: 'lib-convenio-recebimento',
  templateUrl: './convenio-recebimento.component.html',
})
export class ConvenioRecebimentoComponent implements OnInit, OnChanges, OnDestroy {

  protected unsubscribe: Subject<void> = new Subject();

  public paginaCorrente: number = 1;
  public paginaTotal: number;
  public limite: number = 20;
  public recebimentosVisualizacao = []
  public recebimentos: any;

  @Input() convenio: Convenio;
  @Input() login: Login;
  
  constructor(
    protected confirmationService: ConfirmationService,
    protected funcaoService: FuncaoService,
    protected messageService: MessageService,
    protected recebimentoService: RecebimentoService
  ) { }

  async ngOnInit() {
    await this.buscarRecebimentos();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  public exportarXLSX() {
    const listaItens = new Array();
    for (const item of this.recebimentos.content) {
      const entity = {
        data_recebimento: this.funcaoService.converteDataBR(item.data_recebimento),
        ficha: item.ficha.numero,
        codigo: item.ficha.receita.codigo,
        receita: item.ficha.receita.nome,
        conta_bancaria: `${item.conta.numero_conta} ${item.conta.digito_conta} ${item.conta.nome}`,
        guia: item.guia,
        valor_recebimento: item.valor_recebido
      };
      listaItens.push(entity);
    }
    tsXLXS().exportAsExcelFile(listaItens).saveAsExcelFile(`recebimentos - ${this.convenio.numero} ${this.convenio.ano}`);
  }

  public async proximaPagina() {
    if (this.paginaCorrente < this.paginaTotal) {
      this.paginaCorrente++;
      await this.buscarRecebimentos();
      window.scrollTo(0, 0);
    }
  }

  public async paginaAnterior() {
    this.paginaCorrente = this.paginaCorrente === 1 ? 1 : this.paginaCorrente - 1;
    await this.buscarRecebimentos();
    window.scrollTo(0, 0);
  }

  public async paginaDigitada(pagina: number) {
    this.paginaCorrente = pagina >= this.paginaTotal ? this.paginaTotal : pagina;
    await this.buscarRecebimentos();
    window.scrollTo(0, 0);
  }

  public async mudarLimite(limite: number) {
    this.limite = limite;
    this.paginaDigitada(1);
    await this.buscarRecebimentos();
  }

  public preencherEmpVisualizacao() {
    const inicio = (this.paginaCorrente - 1) * this.limite;
    const fim = inicio + this.limite;
    this.recebimentosVisualizacao = this.recebimentos.content.slice(inicio, fim);
  }

  public async buscarRecebimentos(pagina: number = this.paginaCorrente) {
    this.recebimentos = await this.recebimentoService.filtrar(pagina, this.limite, {
      'ficha.aplicacao_variavel.id': this.convenio.aplicacao_variavel.id,
      orgao_id: this.login.orgao.id,
      ignoreCondObrig: true,
      relations: 'ficha.aplicacao_variavel,ficha.receita,conta'
    }).toPromise();

    this.paginaTotal = +this.recebimentos.totalPages;
    this.preencherEmpVisualizacao();
  }
}
